<template>
  <div class="base_text_area_div">
    <a-row class="text_tip">
      {{baseTip}}
    </a-row>
    <a-row class="text_tip" v-if="activityKey !== '6'">
    不知道怎么写？输入您的产品或服务名称后点击AI生成试试
    </a-row>
    <a-row>
      <a-textarea class="custom_textarea" :rows="20" :disabled="false" v-model="baseContent.text" @change="baseTextareaChange">
      </a-textarea>
      <a-spin v-if="loadingBaseCreate" size="large" wrapperClassName="loadingBaseClass" class="loadingBaseClass" style="position: absolute;top: 50%;left:50%"/>
    </a-row>

    <!--服务信息指南和功能按钮-->
    <a-row  style="text-align: left;margin: 13px 0 0 0" v-if="activityKey !== '6'">
      <a-icon type="exclamation-circle" theme="filled" style="color: #28E04A;font-size: 14px;" />
      <span style="color: #28E04A;font-size: 12px;" @click="showServiceGuide"> 服务信息填写指南 </span><br/>
      <span  style="font-size: 12px;font-weight: 400;color: rgba(255,255,255,0.8);line-height: 12px;" >
        您可以提供核心信息后点击“A生成”，在生成内容上编辑。
      </span>
    </a-row>

    <a-row type="flex" style="margin: 38px 20px 8px 0;padding: 0 15%">
      <a-col flex="1" style="text-align: left" v-if="activityKey !== '6'">
        <a-button class="btn_upload" @click="showLoginPanel" v-if="!$store.state.userAuth.haveLogin"> 尚未登录 </a-button>
<!--        <a-button class="btn_upload" v-if="$store.state.userAuth.haveLogin" @click="jieCheckSelfBase"> AI自查 </a-button>-->
        <a-button class="btn_upload" v-if="$store.state.userAuth.haveLogin" @click="smartCreate"> AI生成 </a-button>
      </a-col>
      <a-col flex="1" class="div_right" :class="{'div_center': this.activityKey === '6'}"
             v-if="$store.state.userAuth.haveLogin && this.activityKey === '6' && this.$store.state.userInfo.is_customized_member === 1">
        <!-- 其他模块新增excl文件上传 -->
        <a-upload style="width: 120px; height: 40px;margin-right: 20px"
                   name="file"
                   :multiple="false"
                   listType="text"
                   :file-list="fileList"
                   @change="handleFileChange"
                   :before-upload="handleBeforeUpload"
                   accept=".xlsx,.xls,.csv"
                   :custom-request="customUpload"
        >
          <a-button class="btn_upload" style="width: 120px; height: 40px;margin-right: 20px" @click="uploadExcelFile" >
            Excel上传
          </a-button>
        </a-upload>
      </a-col>
      <a-col flex="1" >
        <a-button type="primary" class="btn_save" style="width: 120px;" @click="jieSaveBase" v-if="$store.state.userAuth.haveLogin">
          保 存
        </a-button>
      </a-col>
    </a-row>

    <a-modal centered v-model="checkBaseDialogVisible" title="AI自查结果" class="base_feedback_dialog">
      <template slot="footer" style="text-align: center" class="base_feedback_dialog_footer">
        <div style="text-align: center">
          <a-button type="primary" key="cancel" @click="checkBaseDialogVisible = false" style="background: rgb(17, 159, 250) !important;border-color:rgb(17, 159, 250) !important;">
            知道了
          </a-button>
        </div>

      </template>
      <a-spin size="large" v-if="loadingBaseFeedback" style="width: 100%"/>
      <span v-if="!loadingBaseFeedback"> {{checkBaseResult}} </span>
    </a-modal>

    <!--服务填写指南框-->
    <a-modal
      title="服务信息填写指南"
      :visible="showServiceGuideModal"
      @cancel="showServiceGuideModal = false"
      :closable="true"
      :maskClosable="true"
      class="serviceGuideModal"
      :footer="null"
      :centered="true"
    >
      <div style="font-size: 16px;font-weight: 400;color: #000000;line-height: 19px; white-space: pre-line;">
        <div class="title_h2" style="margin-top: 0">引言 </div>
        欢迎使用私有知识库！本指南将帮助您有效地展示您的产品和服务，提高销售效率并赢得客户信任。建议您按照我们的步骤逐个模块填写信息，初次填写时无需追求完美，您可以通过app端AI自查工具根据您的内容获得反馈，帮助您不断完善。
        <div class="title_h2">填写原则</div>
        <div class="title_h3">
          • 精确性： 请确保您提供的信息全面且正确。
          • 用户导向：内容应基于用户需求，简明易懂。
          • 一致性：全文内容需保持一致，避免与实际产品信息相冲突。
        </div>
        <div class="title_h2">主要内容</div>
        <div class="title_h3"></div>
        1. 个人及企业信息
        • 目的：准确展示您的个人或企业信息，突出您的专业优势和值得信赖的因素。
        • 内容：包括基本信息，如专业背景、行业经验、公司规模等；荣誉或成就，如奖项、重大项目或成功案例等；专业优势，如技术优势、研发成果或专利技术等，可以展示独特的产品价值。
        2. 产品服务概述
        • 目的：通过准确描述产品和服务的独特价值，快速吸引用户的兴趣和建立信任。
        • 内容：明确的行业观点和价值主张，对用户区分您与其他同行业竞争者具有重要参考意义；详细介绍业务范围和产品线；用数据或案例证明您的竞争优势。
        3. 服务人群画像
        • 目的：精确描绘目标用户群特征，以更有效地推荐和定位产品服务。
        • 内容：描述服务对象的类型和特征，附带购买动机和使用场景的具体案例。
        4. 购买方式及注意事项
        • 目的：清晰说明购买流程和注意事项，引导用户顺利完成购买。
        • 内容：指明是否需预咨询、是否提供定制产品等，具体的购买方式以及重要购买须知。
        5. 售后服务
        • 目的：详细阐述售后服务政策，增强用户信任，清晰解答售后疑问。
        • 内容：包括交付时间、配送范围、物流跟踪方式；退款退货的条件、流程和时限；其他相关后续服务。
        <div class="title_h2">其他</div>
        对于初次接触该行业或产品的用户可能提出的问题，您可能需要补充相关信息，以提高AI的回答精确度。
        <div class="title_h2">结语</div>
        遵循本指南填写信息，您将能建立一个更加精确和用户友好的私有知识库，帮助您的AI智能体更有效地销售产品，促进业绩增长。祝您填写顺利！

      </div>
    </a-modal>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'MyComponent',
  components: {},
  props: {
    activityKey: {
      type: String,
      default: '1'
    },
    baseContent: {
      type: Object,
      default: () => {
        return {
          'score': 0,
          'text': ''
        }
      }
    }
  },
  watch: {
    baseText (newValue, oldValue) {
      // 区分首次赋予数据 改变状态其实也要是未改变
      if (oldValue !== '') {
        this.isChangeText = true
      }
      /* else {
        // 首次赋予获得接口数据的问题
        this.tempCompareText = newValue
      } */
    }
  },
  data () {
    return {
      checkBaseDialogVisible: false,
      checkBaseResult: '',
      checkBaseScore: 0,
      loadingBaseFeedback: true,
      loadingBaseCreate: false,
      isChangeText: false,
      tempCompareText: '',
      showServiceGuideModal: false,
      fileList: [
      ],
      excelUploadAction: this.$store.state.apiHost + '/api/user/upload_customized_file'
    }
  },
  computed: {
    baseText () {
      return this.baseContent.text
    },
    baseTip () {
      let baseTipText = ''

      switch (this.activityKey) {
        case '1':
          baseTipText = '请介绍一下您的从业背景、从业时长、业绩表现以及公司在行业内的口碑、荣誉等。'
          break
        case '2':
          baseTipText = '请介绍一下您的产品是什么，对用户来说作用是什么，对比竞争对手您的优势是什么。'
          break
        case '3':
          baseTipText = '请介绍一下您的产品是卖给谁的，他们的特征是什么，为什么要买您的产品。请提供一些准确的成功案例。'
          break
        case '4':
          baseTipText = '请介绍一下您的产品应该在哪里怎么购买，购买前需要提供什么信息或者如有其他注意事项请说明。'
          break
        case '5':
          baseTipText = '请介绍一下购买您的产品之后如果有产品质量或者其他问题需要咨询或者退换货等，应该怎么操作。'
          break
        case '6':
          baseTipText = '若您有之前模块未覆盖的内容，请填写。'
          break
        default:
          baseTipText = '若您有之前模块未覆盖的内容，请填写。'
          break
      }
      return baseTipText
    }
  },
  mounted () {
    this.tempCompareText = this.baseText
    this.setIsChangeText()
  },
  methods: {
    showServiceGuide () {
      this.showServiceGuideModal = true
    },
    jieCheckSelfBase () {
      this.$emit('jieCheckSelfBase')
    },
    showLoginPanel () {
      this.$emit('showLoginPanel')
    },
    jieSaveBase () {
      this.$emit('jieSaveBase')
    },
    // ui工具
    baseTextareaChange (event) {
      /* console.log('on baseTextarea Chang event:', event.target._value)
      console.log('default old', this.baseContent.text)
      this.isChangeText = true */
    },
    getIsChangeText () {
      // console.log('isChangeText', this.activityKey, this.isChangeText)
      return this.isChangeText
    },
    setIsChangeText () {
      this.isChangeText = false
    },
    // 核心逻辑
    checkSelfBase () {
      if (this.baseContent.text === '') {
        this.$message.error('自查内容不得为空，请输入相关内容')
        return
      }
      try {
        let activityKeyNumber = parseInt(this.activityKey)
        this.checkBaseDialogVisible = true
        this.loadingBaseFeedback = true
        this.$api.checkSelfBase(activityKeyNumber, this.baseContent.text).then(res => {
          if (res && res.status === 200) {
            const resData = res.data.data
            console.log('resData.tips', resData.tips)
            this.checkBaseResult = resData.tips
            this.checkBaseScore = resData.score
            this.loadingBaseFeedback = false
          }
          this.loadingBase = false
        }).catch(error => {
          this.loadingBaseFeedback = false
          if (typeof error.data !== 'undefined') {
            let res = error.data
            this.$message.error(res.msg || '自查失败，请稍后重试')
          } else {
            this.$message.error('自查失败，请稍后重试')
          }
          console.log('error', error)
          this.loadingBase = false
        })
      } catch (error) {
        console.log('activityKeyNumber translate error', error)
      }
    },
    smartCreate () {
      if (this.baseContent.text === '') {
        this.$message.error('请先输入基本内容')
        return
      }
      this.loadingBaseCreate = true
      let contentType
      switch (this.activityKey) {
        case '1':
          contentType = 12
          break
        case '2':
          contentType = 13
          break
        case '3':
          contentType = 14
          break
        case '4':
          contentType = 15
          break
        case '5':
          contentType = 16
          break
        default:
          contentType = 17
          break
      }
      let params = {
        content_type: contentType,
        text: this.baseContent.text
      }
      this.$api.contentFromAi(params).then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          if (resData.info !== '') {
            this.baseContent.text = resData.info
            this.loadingBaseCreate = false
          }
        }
      }).catch(error => {
        this.loadingBaseCreate = false
        if (typeof error.data !== 'undefined') {
          let res = error.data
          this.$message.error(res.msg || 'AI生成失败，请稍后重试')
        } else {
          this.$message.error('AI生成失败，请稍后重试')
        }
        console.log('error', error)
      })
    },
    saveBase () {
      console.log('saveBase index:', this.activityKey)
      if (this.baseContent.text === '') {
        this.$message.error('内容不得为空，请输入相关内容')
        return
      }
      if (this.tempCompareText === this.baseContent.text) {
        this.$message.error('当前信息已录入，请勿重复提交')
        return
      }
      try {
        let activityKeyNumber = parseInt(this.activityKey)
        if (this.checkBaseScore === 0) {
          this.checkBaseScore = this.baseContent.score
        }
        this.$api.updateArticle(activityKeyNumber, this.checkBaseScore, this.baseContent.text).then(res => {
          if (res && res.status === 200) {
            this.isChangeText = false
            this.tempCompareText = this.baseText
            console.log('this.isChangeText = false')
            this.$message.success(res.msg || '模块知识库更新成功')
          }
        }).catch(error => {
          this.loadingBaseFeedback = false
          if (typeof error.data !== 'undefined') {
            let res = error.data
            this.$message.error(res.msg || '保存失败，请稍后重试')
          } else {
            this.$message.error('保存失败，请稍后重试')
          }
          console.log('error', error)
        })
      } catch (error) {
        console.log('activityKeyNumber translate error', error)
      }
    },
    uploadExcelFile () {

    },
    handleFileChange (info) {
      // 文件状态改变的回调 上传中、完成、失败都会调用这个函数
      console.log('handleFileChange info :', info) // 包含了file 和 fileList
      console.log('handleFileChange fileList:', info.fileList)
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      this.fileList = fileList
    },
    handleBeforeUpload (file) {
      // 预览文件内容
      console.log('file:', file.type, file)
      if (file.type === 'application/vnd.ms-excel' ||
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        file.type === 'text/csv') {
        if (file.size / 1024 / 1024 > 1) {
          this.$message.error('文件大小不能超过1M！')
          return false // 阻止文件上传
        }
      } else {
        this.$message.error('请选择一个文本格式的文件！')
        return false // 阻止文件上传
      }
    },
    customUpload (options) {
      // 上传产品图片
      // 创建一个 FormData 对象
      console.log('handleCustomRequest', options)
      let fileItem = options.file
      const formData = new FormData()
      formData.append('file', fileItem, fileItem.name)
      formData.append('name', fileItem)
      let token = this.$store.state.userAuth.userToken
      if (token === '' || typeof token === 'undefined') {
        this.$message.error('请重新登录')
        return
      }
      axios.post(this.excelUploadAction, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        // console.log('response', response)
        if (response.status === 200) {
          console.log('上传成功', response.data.data.url)
          this.$message.success('文件上传成功')
          const resultUrl = response.data.data.url
          this.fileList[this.fileList.length - 1].status = 'done'
          this.fileList[this.fileList.length - 1].url = resultUrl
        }
      }).catch(error => {
        console.log('error', error)
        let errorMsg = ''
        if (error && error.msg) {
          errorMsg = error.msg
        }
        this.clearList()
        this.$message.error('上传失败请重试' + errorMsg)
      })
    },
    clearList () {
      this.fileList = []
    }
  }
}
</script>

<style scoped >
.div_right{
  text-align: right
}
.div_center{
  text-align: center !important;
}
.base_text_area_div{
  padding-top: 10px;
}
.text_tip{
  font-size: 16px;
  color: rgb(207, 208, 211);
  text-align: left;
  margin: 0 5px 5px 0;
}
.custom_textarea{
  background: none;
  border-color:  rgba(153,153,153,0.5);
  color: rgba(255,255,255,0.8);
  margin-bottom: 10px;
  scrollbar-width: thin;
  scrollbar-color: #999999 #f5f5f5;
  padding: 16px;
}
.custom_textarea::-webkit-scrollbar {
  width: 8px;
}

.custom_textarea::-webkit-scrollbar-track {
  background-color: #f5f5f5;
}

.custom_textarea::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 4px;
}

.custom_textarea::-webkit-scrollbar-thumb:hover {
  background-color: #888888;
}

</style>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mini/BaseTextArea.vue